import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { supplier, suppliersSlice, suppliersState } from './SuppliersSlice';
import { addSupplierSlice } from './AddModal/AddModalSlice';

// API
import { sortDirectionType } from '../../services/api/api';

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar';

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';
import { Confirm } from '../../components/Alerts/Alerts';
import AddModal from './AddModal/AddModal';

import {
  showSupplierSlice,
} from './ShowModal/ShowModalSlice';
import { havePermission } from '../../services/hoc/permissions';
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import {

  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import Grid from '@mui/material/Grid'
import GreenButton from '../../components/buttons/green-button';
import WhiteButton from '../../components/buttons/white-button';
import SuppliersDetails from './ShowModal/suppliers_details';
import { LaunchOutlined } from '@mui/icons-material';
import { useNotification } from '../../services/usenotification';
import { getListSort } from '../../services/hoc/sort';
import { SortTable } from '../../components/Table/SortTable';
import { RowContainer } from '../../components/Table/row_container';
import SettingContext from '../../services/context/setting-contentxt/setting-context';

import { useAPI } from '../../services/hoc/useAPI';
import { AxiosError } from 'axios';

const Suppliers= () => {
  
  // Translation
  const t = useTranslation();
  const { alertError500 } = useNotification();
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
  // Redux
  const dispatch = useDispatch();
  const [supplierDetail, setSupplierDetails] = useState<any>();
  const state = useSelector(
    (state: { suppliers: suppliersState }) => state.suppliers,
  );

  const sort_fields = useRef<{sort_field?:number,sort_direction?:sortDirectionType}>({})
  // Hooks
  
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
    const {isMobile} =useContext(SettingContext)
    const ENDPOINTS = useAPI()
    const keyword_ref = useRef<string|null>(null)

  // Search
  const search = (value: string) => {
    dispatch(suppliersSlice.actions.reset());
    keyword_ref.current = Boolean(value)?value:null
    fetchData(1, Boolean(value) ? 20 : 8, value);
  };

  // Fetch Data
  const fetchData = useCallback((page: number
                               , page_size: number = 8
                               , keyword?: string
                               , sort_direction?:sortDirectionType
                               , sort_field?:number) => {
    dispatch(suppliersSlice.actions.setIsFetching(true));
    keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.suppliers()
      .index({
        page,
        page_size,
        keyword,
        sort_direction,
        sort_field,
      })
      .then((response: any) => {
        dispatch(suppliersSlice.actions.setIsFetching(false));
        dispatch(suppliersSlice.actions.setPage(pagesInfo.page));
        if (response.data.data.last_page)
          setPagesInfo((pre) => ({
            ...pre,
            lastPage: response.data.data.last_page,
          }));
        let suppliers: supplier[] = response.data.data.suppliers.map(
          (supplier: any): supplier => supplier,
        );

        dispatch(suppliersSlice.actions.init(suppliers));
        dispatch(
          suppliersSlice.actions.setHasMore(
            page < Number(response.data.data.last_page),
          ),
        );
        if (!state.isLoaded) dispatch(suppliersSlice.actions.setIsLoaded(true));
      })
      .catch((err:AxiosError)=>{
         dispatch(suppliersSlice.actions.setIsFetching(false));
         alertError500(err)
      })
  },[ENDPOINTS,dispatch,pagesInfo.page,state.isLoaded])

  const fetchSortedData = useCallback((
    sort_field: number,
    sort_direction: sortDirectionType,
  ) => {
    if (sort_direction && sort_field) {
             sort_fields.current.sort_direction=sort_direction 
      sort_fields.current.sort_field=sort_field
     
     
        fetchData(state.page, 8,'',sort_direction,sort_field);
      //setSortOptions((pre) => ({ ...pre, sort_direction, sort_field }));
    }
  },[state.page])


  const reports = (supplier: supplier) => (
    <div className="reports">
      <Tooltip title={t('purchase_orders')}>
        <div style={{ display: 'inline' }}>
          <i
            className="icon-orders"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              navigate('/purchase-orders', { state: { key: supplier.name } });
            }}
          />
        </div>
      </Tooltip>
      <Tooltip title={t('purchase_bills')}>
        <div style={{ display: 'inline' }}>
          <i
            className="icon-receipt"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              navigate('/purchase-bills', { state: { key: supplier.name } });
              e.stopPropagation();
            }}
          />
        </div>
      </Tooltip>

      <Tooltip title={t('payment_vouchers')}>
        <div style={{ display: 'inline' }}>
          <i
            className="icon-voucher"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              navigate('/payment-vouchers', {
                state: { key: supplier.name },
              });
            }}
          />
        </div>
      </Tooltip>
      <Tooltip title={t('print_supplier_account')}>
        <Link
          to={`/spreedsheet/getSupplierReport/1990-01-01/${new Date().toLocaleDateString(
            'en-CA',
          )}/${supplier.id}`}
          data-tip={t('account_statment')}
          target="_blank">
          <i
            className="icon-tasks"
            onClick={(e: React.MouseEvent<HTMLLIElement>) =>
              e.stopPropagation()
            }
          />
        </Link>
      </Tooltip>
    </div>
  );
  const actions = (supplier: supplier) => (
    <div className="show-on-hover">
      {havePermission('Show Supplier') ? (
        <Tooltip title={t('info')}>
          <i
            className="icon-info"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              fetchSuppliersDetails(supplier.id);
              e.stopPropagation();
              setIsOpen(true);

              dispatch(
                showSupplierSlice.actions.setIsOpen({
                  id: supplier.id,
                  isOpen: true,
                }),
              );
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
      {havePermission('Edit Supplier') ? (
        <Tooltip title={t('edit')}>
          <i
            className="icon-edit"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              dispatch(addSupplierSlice.actions.setIsOpen(true));
              dispatch(addSupplierSlice.actions.setEditId(supplier.id));
              dispatch(addSupplierSlice.actions.setIsLoading(true));
              ENDPOINTS.suppliers()
                .show({ id: supplier.id })
                .then((response: any) => {
                  dispatch(addSupplierSlice.actions.set(response.data.data));
                  dispatch(addSupplierSlice.actions.setIsLoading(false));
                });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
      {havePermission('Delete Supplier') ? (
        <Tooltip title={t('delete')}>
          <i
            className="icon-delete"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(supplier.id),
              });
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
    </div>
  );
  const rows = () => {
    return state.suppliers[state.page]
      ? state.suppliers[state.page].map((supplier, index) => {
          return (
            <RowContainer
            key={index}
              item_id={supplier.id.toString()}
              state_length={state.suppliers[state.page].length}
              tr_index={index}
              onSelect={toggleSelectedId}
              columns={[
                supplier.serial_no,
                supplier.name,
                supplier.account_no,
                supplier.phone,
                supplier.email,
                reports(supplier),
                actions(supplier),
              ]}
            />
          );
        })
      : null;
  };
  const fetchSuppliersDetails = (id: number) => {
    ENDPOINTS.suppliers()
      .show({ id })
      .then((response: any) => {
        setSupplierDetails({
          id,
          name: response.data.data.name,
          account_no: response.data.data.account_no,
          serial_no: response.data.data.serial_no,
          phone: response.data.data.phone,
          fax: response.data.data.fax,
          mobile: response.data.data.mobile,
          email: response.data.data.email,
          website: response.data.data.website,
          country: response.data.data.country,
          government: response.data.data.government,
          city: response.data.data.city,
          postal_code: response.data.data.postal_code,
          department_number: response.data.data.department_number,
          address_1: response.data.data.address_1,
          address_2: response.data.data.address_2,
          address_3: response.data.data.address_3,
        });
        dispatch(showSupplierSlice.actions.setIsLoaded(true));
      });
  };
  const generateClientData = () => {
    if (supplierDetail) {
      return (
        <Grid container rowGap={2}>
          <Grid container size={12} alignItems="end">
            <Grid container size={6} columnGap={{ sm: 1 }}>
              <Grid size= {{lg:3 , sm :5 ,xs :5}}>
                <GreenButton
                  label={t('edit_supplier')}
                  disabled={!havePermission('Edit Supplier')}
                  fun={() => {
                    if (havePermission('Edit Supplier')) {
                      setIsOpen(false);
                      dispatch(addSupplierSlice.actions.setIsOpen(true));
                      dispatch(
                        addSupplierSlice.actions.setEditId(supplierDetail.id),
                      );
                      dispatch(addSupplierSlice.actions.setIsLoading(true));
                      ENDPOINTS.suppliers()
                        .show({ id: supplierDetail.id })
                        .then((response: any) => {
                          dispatch(
                            addSupplierSlice.actions.set(response.data.data),
                          );
                          dispatch(
                            addSupplierSlice.actions.setIsLoading(false),
                          );
                        })
                        .catch((err: any) => {
                          dispatch(
                            addSupplierSlice.actions.setIsLoading(false),
                          );
                          alertError500(err);
                        });
                    }
                  }}>
                  <i className="icon-edit" />
                </GreenButton>
              </Grid>
              <Grid size= {{lg: 3 ,sm :5 ,  xs :5}} >
                <WhiteButton
                  label={t('delete_supplier')}
                  disabled={!havePermission('Delete Supplier')}
                  fun={() =>
                    havePermission('Delete Supplier') &&
                    Confirm({
                      message: t('delete_confirmation'),
                      onConfirm: () => remove(supplierDetail.id),
                    })
                  }>
                  <i className="icon-delete" style={{ color: 'red' }} />
                </WhiteButton>
              </Grid>
            </Grid>
            <Grid container size={6} alignItems="end" columnGap={{sm:1,xs:0}}
            sx={{marginBottom:{xs:'0.5rem',sm:'0'}}}>

               <Grid size = {{lg: 3,  sm : 3 , xs: 3}} >
              
                              { isMobile?
                              <div className="show-on-hover" onClick={() => {
                                  navigate(`/purchase`, { state: { key: supplierDetail.name } });
                                }}>
                               <div className='quick_link'>
                                   <span>{t('purchase_orders')}</span>
                                    <LaunchOutlined sx={{ 
                                      color: isMobile?'var(--primary-color)':'white' ,
                                      fontSize:{xs:'0.5rem',sm:'1rem'}
                                      }} />
                                  </div>
                                  </div>
                              :
                                <GreenButton
                                    label={t('purchase_orders')}
                                    fun={() => {
                                      navigate(`/purchase-orders`, {
                                        state: { key: supplierDetail.name },
                                      });
                                                          }}>
                                        <div className="show-on-hover">
                                      
                                          <div>
                                            <LaunchOutlined sx={{ color: 'white' }} />
                                          </div>
                                        </div>
                                  </GreenButton>}
                </Grid>
                <Grid size = {{lg:3, sm:3, xs:3}} >
  
                  { isMobile?
    
                    <div className="show-on-hover" onClick={() => {
                        navigate(`/purchase_bills`, { state: { key: supplierDetail.name } });
                      }}>
                    <div className='quick_link'>
                        <span>{t('purchase_bills')}</span>
                          <LaunchOutlined sx={{ 
                            color: isMobile?'var(--primary-color)':'white' ,
                            fontSize:{xs:'0.5rem',sm:'1rem'}
                            }} />
                        </div>
                        </div>
                  :
                    <GreenButton
                      label={t('purchase_bills')}
                      fun={() => {
                        navigate('/purchase-bills', {
                          state: { key: supplierDetail.name },
                        });
                      }}>
                      <div className="show-on-hover">
                        <LaunchOutlined sx={{ color: 'white' }} />
                      </div>
                    </GreenButton>
                    }
                </Grid>
                <Grid size = {{lg:3, sm:3, xs:3}} >
                {  isMobile?
                  <div className="show-on-hover" onClick={() => {
                      navigate(`/payment_vouchers`, { state: { key: supplierDetail.name } });
                    }}>
                    <div className='quick_link'>
                        <span>{t('payment_vouchers')}</span>
                        <LaunchOutlined sx={{ 
                          color: isMobile?'var(--primary-color)':'white' ,
                          fontSize:{xs:'0.5rem',sm:'1rem'}
                          }} />
                      </div>
                      </div>
                
                :
                  <GreenButton
                        label={t('payment_vouchers')}
                        fun={() => {
                          navigate('/payment-vouchers', {
                            state: { key: supplierDetail.name },
                          });
                        }}>
                        <div className="show-on-hover">
                          <LaunchOutlined sx={{ color: 'white' }} />
                        </div>
                  </GreenButton>
                  }
                </Grid>
            </Grid>
          </Grid>
          <Grid size={12}>
            <Grid size={12}>
              <span
                style={{ fontWeight: 'bold' }}
                className="primary-font-color">
                {' '}
                {t('supplier_information')}{' '}
              </span>
            </Grid>
            <Grid size={12}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow
                     sx={
                      {  
                      '& .MuiTableCell-root':{
                            fontSize:{sm:'0.7rem',lg:'1rem', xs:'0.5rem'},
                       
                      }
                    }}>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {t('supplier_name')}{' '}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {' '}
                        {t('account_number')}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {t('serial_numbe')}{' '}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {t('tax_number')}{' '}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        النوع{' '}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {' '}
                        سقف المديونية
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {' '}
                        {t('phone_number')}
                      </TableCell>

                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {' '}
                        {t('phone')}{' '}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {t('email')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                        '& .MuiTableCell-root':{
                          fontSize:{sm:'0.7rem',lg:'1rem',xs:'0.5rem'},
                         
                        }
                      }}>
                      <TableCell align="right">{supplierDetail.name}</TableCell>

                      <TableCell align="right">
                        {supplierDetail.account_no}
                      </TableCell>
                      <TableCell align="right">
                        {supplierDetail.serial_no}{' '}
                      </TableCell>
                      <TableCell align="right">
                        {supplierDetail.tax_number}
                      </TableCell>
                      <TableCell align="right">{supplierDetail.type}</TableCell>
                      <TableCell align="right">
                        {supplierDetail.debt_ceiling}
                      </TableCell>
                      <TableCell align="right">
                        {supplierDetail.phone}
                      </TableCell>

                      <TableCell align="right">
                        {' '}
                        {supplierDetail.mobile}
                      </TableCell>
                      <TableCell align="right">
                        {supplierDetail.email}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          <Grid size={12}>
            <Grid size={12}>
              <span
                style={{ fontWeight: 'bold' }}
                className="primary-font-color">
                {t('supplier_address')}
              </span>
            </Grid>
            <Grid size={12}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow
                     sx={
                      {  
                      '& .MuiTableCell-root':{
                                 fontSize:{sm:'0.7rem',lg:'1rem', xs:'0.5rem'},
                       
                      }
                    }}
                    >
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {' '}
                        الدولة
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        المحافظة
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        المدينة
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {' '}
                        الرقم البريدي
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        رقم الشقة
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        عنوان 1
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        عنوان 2
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        عنوان 3
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {' '}
                        {t('website')}{' '}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {' '}
                        {t('fax')}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                         '& .MuiTableCell-root':{
                          fontSize:{sm:'0.7rem',lg:'1rem',xs:'0.5rem'},
                         
                        }
                      }}>
                      <TableCell align="right">
                        {supplierDetail.country}
                      </TableCell>

                      <TableCell align="right">
                        {supplierDetail.government}
                      </TableCell>
                      <TableCell align="right">
                        {supplierDetail.city}{' '}
                      </TableCell>
                      <TableCell align="right">
                        {supplierDetail.postal_code}
                      </TableCell>
                      <TableCell align="right">
                        {supplierDetail.department_number}
                      </TableCell>
                      <TableCell align="right">
                        {' '}
                        {supplierDetail.address_1}
                      </TableCell>
                      <TableCell align="right">
                        {' '}
                        {supplierDetail.address_2}
                      </TableCell>
                      <TableCell align="right">
                        {supplierDetail.address_3}
                      </TableCell>
                      <TableCell align="right">
                        {supplierDetail.website}
                      </TableCell>
                      <TableCell align="right"> {supplierDetail.fax}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Grid>
      );
    }
    return (
      <div className="center">
        <EllipsisLoader />
      </div>
    );
  };

  // Toggle Selected id
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const toggleSelectedId = (id: number) => {
    if (!havePermission('Delete Supplier')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(suppliersSlice.actions.setIsLoading(true));
    ENDPOINTS.suppliers()
      .delete({ ids })
      .then(() => {
        if (isOpen) setIsOpen(false);
        setSelectedIds([]);
        dispatch(suppliersSlice.actions.setIsLoading(false));
        dispatch(suppliersSlice.actions.deleteSuppliers(ids));
      }).catch((err:AxiosError)=>{
                  alertError500(err)
                 dispatch(suppliersSlice.actions.setIsLoading(false));
                 })
  };

  // First fetch

  useEffect(() => {
    if (!state.isLoaded && !state.isFetching) fetchData(1);
  }, []);

  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
      if (!state.isFetching) {
        suppliersSlice.actions.setPage(pagesInfo.page);
        fetchData(pagesInfo.page,8,'',sort_fields.current.sort_direction,sort_fields.current.sort_field);
      }
    }
  }, [pagesInfo.page]);



  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading ? <WhiteboxLoader /> : ''}
          <TableActionBar
            title={t('suppliers')}
            search={search}
            showFilter={false}
            showDelete={selectedIds.length > 0}
            delete={() => {
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(),
              });
            }}
            addText={t('add_to_suppliers')}
            add={
              havePermission('Add Supplier')
                ? () => dispatch(addSupplierSlice.actions.setIsOpen(true))
                : undefined
            }
          />

          <SortTable
            header={[
              t('serial_no'),
              t('name'),

              t('account_no'),
              t('phone'),
              t('email'),
              t('reports'),
              '',
            ]}
            onSelect={toggleSelectedId}
            hasMore={state.hasMore}
            loadMore={fetchData}
            pagesInfo={pagesInfo}
            setPagesInfo={setPagesInfo}
            sort_fields={getListSort(
              [
                'serial_no',
                'name',
                'account_no',
                'phone',
                'email',
                'reports',
                '',
              ],
              'Supplier',
            )}
            fetchSortedData={fetchSortedData}
            state={state.suppliers[state.page] ?? []}>
            <>{rows()}</>
          </SortTable>
          <ReactTooltip place="top" variant="dark" float={true} offset={10} />

          <AddModal />

          {/* <ShowSupplier /> */}
          <SuppliersDetails
            data={generateClientData()}
            open={isOpen}
            setOpen={setIsOpen}
          />
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
export default Suppliers ;